import React from 'react'
import clsx from 'clsx'
import { alpha, makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import ProgressBar from '../ProgressBar'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1),
  },
  stackRow: {
    paddingTop: theme.spacing(1),
    display: 'flex',
    '& .stack-row-name': {
      flex: '52% 0 0',
    },
    '& .stack-row-count': {
      flex: '13% 0 0',
      textAlign: 'right',
      paddingRight: theme.spacing(1.5),
    },
  },
}))

const GenericStack = ({ items, ...props }) => {
  const classes = useStyles()

  const getStackRow = ({
    color,
    ratio,
    name,
    displayCount,
    id,
  }) => {
    return (
      <Box className={classes.stackRow} key={id}>
        <Typography
          className="stack-row-name"
          variant="body1"
        >
          {name}
        </Typography>
        <Typography
          className="stack-row-count"
          variant="h3"
          color="textPrimary"
        >
          {displayCount.toLocaleString()}
        </Typography>
        <ProgressBar color={color} ratio={ratio} />
      </Box>
    )
  }

  return (
    <Box
      className={clsx(
        'generic-stack',
        props.classes,
        classes.root,
      )}
    >
      {items.map(getStackRow)}
    </Box>
  )
}

export default GenericStack
